









import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		name: String,
		street: String,
		zip: String,
		city: String,
		url: String,
		distanceLabel: String,
		distanceValue: String,
		distanceSuffix: String,
	},
});
